import React, { useState } from "react";
import UsersList from "../components/Agent/UsersList";
import LayoutPage from "../layouts/Main";

export default function Users(props) {
  const [reload, setReload] = useState(false);

  const handleUserUpdate = () => {
    setReload(!reload);
  };

  return (
    <LayoutPage>
      <UsersList
        reload={reload}
        onUserUpdate={handleUserUpdate}
      />
    </LayoutPage>
  );
}